import { trustPoints } from "@/data/siteConfig";
import { RevealGroup, RevealItem } from "@/components/Reveal";

export const TrustBar = () => (
  <section
    className="border-y border-white/10 bg-ink-surface py-16 md:py-20"
    data-testid="trust-section"
  >
    <div className="mx-auto max-w-[1440px] px-5 md:px-8">
      <RevealGroup className="grid gap-8 sm:grid-cols-2 lg:grid-cols-4">
        {trustPoints.map((t) => {
          const Icon = t.icon;
          return (
            <RevealItem key={t.title} className="flex gap-4">
              <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-sm border border-gold/30 bg-gold/5 text-gold">
                <Icon className="h-6 w-6" />
              </span>
              <div>
                <h3 className="font-heading text-base font-bold text-white">{t.title}</h3>
                <p className="mt-1.5 text-sm leading-relaxed text-steel">{t.body}</p>
              </div>
            </RevealItem>
          );
        })}
      </RevealGroup>
    </div>
  </section>
);
